import { createContext } from 'react';
import type { CustomersContextType } from '../types';

export const CustomersContext = createContext<CustomersContextType | undefined>(undefined);
